export class ApiUrl {
    //Controller
    static EMPLE_C = "/api/Employees/";
    static DEVCE_C = "/api/Devices/";
    static TME_CRD_C = "/api/TimeCard/";
    static PJT_C = "/api/Projects/";
    static ACNT_C = "/api/Account/";
    static DIVIS_C = "/api/Division/";
    static PAYRL_NTE_C = "/api/PayRollNote/";
    static FLDSTSCD_C = "/api/FieldStatusCodeList/";
    static EQMT_C = "/api/Equipment/";
    static DALY_DET_C = "/api/DailyDetails/";
    static TM_VCHR_C = "/api/TMVoucher/";
    static MATE_C = "/api/Material/";
    static SPVRORERN_C = "/api/SupervisorOverrideReason/";

    //Methods
    static IS_DEVCE_ALRDY_REGD = "IsDeviceAlreadyRegistered";
    static GT_REGDEVI_BY_EMPNUM_M = "GetRegiteredWebDevicesByEmployeeNumber";
    static UT_WEBDFIP_M = "UpdateWebDeviceFingerPrintId";
    static REG_DEVCE = "RegisterDevice";
    static LGN_M = "Login";
    static GT_AAEP_M = "GetAllActiveDeviceEmployees";
    static GT_AAPBDID_M = "GetAllActiveProjectsByDeviceId";
    static GT_AAPTKBDID_M = "GetAllActiveProjectTasksByDeviceId";
    static SVE_TIME_CARD_DETLS_M = "SaveTimeCardDetailsWeb";
    static GT_TME_CRD_DTE_RNG = "GetTimeCardsWithDateRange";
    static WNDS_LN_M = "WindowsLogin";
    static GT_A_DVS_LT_M = "GetDivisionList";
    static UPD_DEVICE_M = "UpdateDevice";
    static REGSTR_DEVICE_M = "RegsiterDevice";
    static GT_DEVICE_BY_UUID = "GetDeviceByUUID";
    static GT_DEVCE_M = "GetDevices";
    static GT_PAYRL_NTE_LST_M = "GetPayRollNoteList";
    static SV_PARL_NTE_M = "SavePayRollNote";
    static SV_EXP_NTE_M = "SaveExpectationNote";
    static SV_ACT_NTE_M = "SaveActualNote";
    static GT_ATCHMT_BY_TMC_ID_M = "GetAttachmentByTimeRecordId";
    static GT_ISE_NT_CNT_M = "GetIssueNotesCount";
    static GT_ISE_NT_M = "GetIssueNotes";
    static SV_ISE_NT_M = "SaveIssueNote";
    static DL_TMC_M = "DeleteTimeCard";
    static SV_EMP_GRP_M = "SaveEmployeeGroups";
    static GT_EMP_GRP_M = "GetEmployeeGroups";
    static DL_EMP_GRP_M = "DeleteEmployeeGroups";
    static GT_EMP_GRP_BY_GRP_ID_M = "GetEmployeeGrpByGrpId";
    static SV_TSK_GRP_M = "SaveTaskCodeGroups";
    static GT_TSK_GRP_M = "GetTaskCodeGroups";
    static DL_TSK_GRP_M = "DeleteTaskGroups";
    static GT_TSK_GRP_BY_GRP_ID_M = "GetTaskGrpByGrpId";
    static GT_TMECRDS = "GetTimeCards";
    static CRTE_OR_UPDE_TMECRDS = "CreateOrUpdateTimeCards";
    static SBT_TMRD_M = "SubmitTimeRecords";
    static DL_UA_AND_IA_TMC = "DeleteUnassignedAndInactiveProjectTimecards";
    static SV_JB_WRK_DON_M = "SaveWorkDoneAtJobSite";
    static GT_A_FSCDLTWB_M = "GetFieldStatusCodeListWeb";

    static GT_EQMT_LT_M = "GetEquipmentListWeb";
    static GT_EQMT_M = "GetEquipmentByIdWeb";

    static GT_DALY_DET_LT_M = "GetDailyDetailsWeb";
    static SV_DALY_DET_M = "SaveDailyDetails";
    static GT_DALY_DET_CNT_M = "GetDailyDetailsCount";
    static SV_A_FSCDLT_M = "SaveFieldStatusByTimeRecordId";

    static SV_TM_VCHR_M = "SaveTMVoucherWeb";
    static GT_TM_VCHR_PRJ_TK_LT_M = "GetTMVoucherProjectTaskListWeb";
    static GT_SLCT_TM_VCHR_DET_M = "GetSelectedTMVoucherDetailsWeb";
    static GT_TM_VCHR_CNT_M = "GetTMVouchersCountWeb";
    static IS_TM_VCHR_PRJ_UN_ASD_M = "IsTMVoucherProjectUnAssignedWeb";
    static GT_TM_VCHR_PF_AMT_M = "GetTMVoucherPdfAttachmentWeb";
    static GT_MATE_LT_M = "GetMaterialListWeb";

    static CRTE_OR_UPDE_ATTST = "CreateOrUpdateAttestation";
    static GT_ATTST_BTMCRD_ID_M = "GetAttestionByTimeRecordId";
    static CH_EPE_ARDY_ATTST_TMC = "CheckEmployeeAlreadyAttestedTimeCard";

    static GT_SPVR_ORE_RN_LT_M = "GetSupervisorOverrideReasonListWeb";
};

